// 艺龙酒店直连
export const ylHotelRouter = [
  {
    path: '/service/ylHotel/product',
    name: 'YlHotelProductList',
    component: () => import('@/views/service/serviceProvider/ylHotel/YlHotelProductList'),
    meta: {
      title: '同步产品',
      keepAlive: false
    }
  },
  {
    path: '/service/ylHotel/order',
    name: 'YlHotelOrderList',
    component: () => import('@/views/service/serviceProvider/ylHotel/YlHotelOrderList'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/ylHotel/apiConfigure',
    name: 'YlHotelApiConfigure',
    component: () => import('@/views/service/serviceProvider/ylHotel/YlHotelApiConfigure'),
    meta: {
      title: 'API配置',
      keepAlive: false
    }
  },
  {
    path: '/service/ylHotel/syncRule',
    name: 'YlHotelSyncRule',
    component: () => import('@/views/service/serviceProvider/ylHotel/YlHotelSyncRule'),
    meta: {
      title: '同步规则',
      keepAlive: false
    }
  }
]
